import React, { useState, useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { NotificationManager } from './Notification';
import '../styles/QRCode.css';

const QRCodeGenerator = ({ profile }) => {
  const qrcodeRef = useRef(null);
  const [qrType, setQrType] = useState('vcard'); // 'vcard' ou 'url'

  // Fonction pour générer le contenu vCard
  const generateVCardContent = () => {
    let vcard = 'BEGIN:VCARD\n';
    vcard += 'VERSION:3.0\n';
    vcard += `FN:${profile.firstName} ${profile.lastName}\n`;
    vcard += `N:${profile.lastName};${profile.firstName};;;\n`;
    
    if (profile.company) vcard += `ORG:${profile.company}\n`;
    if (profile.title) vcard += `TITLE:${profile.title}\n`;
    if (profile.phone) vcard += `TEL;TYPE=CELL:${profile.phone}\n`;
    if (profile.email) vcard += `EMAIL:${profile.email}\n`;
    if (profile.website) vcard += `URL:${profile.website}\n`;
    if (profile.address) vcard += `ADR;TYPE=WORK:;;${profile.address};;;;\n`;
    
    // Ajouter la note
    if (profile.note) vcard += `NOTE:${profile.note}\n`;
    
    // Ajouter les réseaux sociaux comme notes 
    if (profile.socials) {
      let socialNote = '';
      if (profile.socials.linkedin) socialNote += `LinkedIn: ${profile.socials.linkedin}\n`;
      if (profile.socials.twitter) socialNote += `Twitter: ${profile.socials.twitter}\n`;
      if (profile.socials.instagram) socialNote += `Instagram: ${profile.socials.instagram}\n`;
      if (profile.socials.facebook) socialNote += `Facebook: ${profile.socials.facebook}\n`;
      if (profile.socials.youtube) socialNote += `YouTube: ${profile.socials.youtube}\n`;
      if (profile.socials.skype) socialNote += `Skype: ${profile.socials.skype}\n`;
      if (profile.socials.whatsapp) socialNote += `WhatsApp: ${profile.socials.whatsapp}\n`;
      if (profile.socials.other) socialNote += `Autre: ${profile.socials.other}\n`;
      
      if (socialNote) {
        vcard += `NOTE:${socialNote}\n`;
      }
    }
    
    vcard += 'END:VCARD';
    
    return vcard;
  };

  // Obtenir le contenu du QR code en fonction du type sélectionné
  const getQRContent = () => {
    if (qrType === 'vcard') {
      return generateVCardContent();
    } else {
      // Format pour Android (matmsg)
      const vcardText = generateVCardContent();
      return `MATMSG:TO:;SUB:Contact - ${profile.firstName} ${profile.lastName};BODY:${vcardText};;`;
    }
  };

  const downloadQRCode = () => {
    try {
      // Téléchargement du QR code en SVG
      const svgElement = qrcodeRef.current.querySelector('svg');
      
      if (!svgElement) {
        NotificationManager.show('Erreur', 'QR code non disponible', 'error');
        return;
      }
      
      // Créer un canvas temporaire
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 240; // 200 + 40 de marge
      canvas.height = 240;
      
      // Fond blanc
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Convertir SVG en image
      const img = new Image();
      const svgData = new XMLSerializer().serializeToString(svgElement);
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(svgBlob);
      
      img.onload = () => {
        // Dessiner l'image au centre du canvas
        ctx.drawImage(img, 20, 20, 200, 200);
        
        // Télécharger l'image
        const dataUrl = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        const firstName = profile.firstName || 'contact';
        const lastName = profile.lastName || '';
        link.download = `qrcode_${firstName}_${lastName}.png`.replace(/\s+/g, '_');
        link.href = dataUrl;
        link.click();
        
        // Libérer les ressources
        URL.revokeObjectURL(url);
        
        NotificationManager.show('Succès', 'QR code téléchargé avec succès', 'success');
      };
      
      img.src = url;
    } catch (error) {
      console.error("Erreur lors du téléchargement du QR code:", error);
      NotificationManager.show('Erreur', 'Impossible de télécharger le QR code', 'error');
    }
  };

  return (
    <div className="qrcode-container">
      <div ref={qrcodeRef} className="qrcode-display">
        <QRCodeSVG 
          value={getQRContent()}
          size={200}
          level="H" // Niveau de correction d'erreur élevé
          includeMargin={true}
          bgColor="#FFFFFF"
          fgColor="#000000"
        />
      </div>
      <div className="qr-notice">Scannez ce QR code pour ajouter directement ce contact</div>
      
      <div className="qr-options">
        <button 
          onClick={() => setQrType('vcard')} 
          className={`qr-type-btn ${qrType === 'vcard' ? 'active' : ''}`}
        >
          Format vCard (iOS)
        </button>
        <button 
          onClick={() => setQrType('url')} 
          className={`qr-type-btn ${qrType === 'url' ? 'active' : ''}`}
        >
          Format Android
        </button>
      </div>
      
      <button onClick={downloadQRCode} className="download-btn">
        Télécharger le QR Code
      </button>
    </div>
  );
};

export default QRCodeGenerator;
